import Component from 'navigation/component/Component';
import mqStore from 'store/mqStore';
import resize from 'helpers/resize';
import AddToWishlist from 'components/add-to-wishlist/AddToWishlist';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import sizeStore from 'store/sizeStore';
import config from 'core/config';
class ProductDetails extends Component {
    isOneSize;
    resizeObserver;
    mutationObserver;
    alignBottom;
    almaContainer;
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            addToWishlist: ['.add-to-wishlist__small', AddToWishlist]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            parent: this.parent
        };
    }
    constructor(el, options) {
        super(el, options);
        this.el = el;
        this.bindRefs(this.el.parentElement);
        if (window.ResizeObserver) {
            this.resizeObserver = new ResizeObserver(this.observerResize);
            this.resizeObserver.observe(this.el);
        }
    }
    initialized() {
        super.initialized();
    }
    async addAlmaWidget() {
        if (!this.refs.price || !window?.Alma)
            return;
        if (this.almaContainer)
            this.almaContainer?.remove();
        requestAnimationFrame(() => {
            this.almaContainer = document.createElement('div');
            this.almaContainer.classList.add('product-infos__alma');
            this.refs?.[mqStore.tabletPortrait.get() ? 'title' : 'notice']?.after(this.almaContainer);
            config.alma.add(window?.Alma.Widgets.PaymentPlans, {
                container: '.product-infos__alma',
                purchaseAmount: Number.parseFloat(this.refs.price?.dataset?.price || '') * 100,
                locale: 'fr',
                monochrome: true,
                hideBorder: true,
                plans: [
                    {
                        installmentsCount: 3,
                        minAmount: 5000,
                        maxAmount: 300000
                    }
                ]
            });
        });
    }
    observerResize = (e) => {
        this.computeAlignement();
    };
    bindModules() {
        super.bindModules();
    }
    bindEvents(add = true) {
        const method = bindMethod(add);
        window[method]('sizebay:rendered', this.refresh.bind(this));
        const emitterMethod = bindEmitterMethod(add);
        // if (this.refs.storeReservation) this.refs.storeReservation[method]('click', this.onClickReservation)
        mqStore.tabletPortrait.listen(this.addAlmaWidget.bind(this));
        const parent = this.parent;
        parent.pageManager[emitterMethod]('show', () => {
            this.addAlmaWidget();
        });
    }
    // onClickReservation = event => {
    //   event.preventDefault()
    //   this.onClickReservationCallback()
    // }
    // onClickReservationCallback = () => {
    //   const size = this.refs.socloz?.getAttribute('data-socloz-product-attributes-clothes_size')
    //   if (!this.refs.socloz || (!size && !this.isOneSize)) return
    //   this.refs.socloz.click()
    // }
    computeAlignement() {
        if (mqStore.tabletPortrait.get())
            return;
        // Compute product details alignement
        const top = (sizeStore.headerHeight.get() + this.el.parentElement.offsetTop);
        const availableHeight = resize.height() - top;
        const alignBottom = this.el.offsetHeight > availableHeight;
        if (this.alignBottom === alignBottom)
            return;
        this.alignBottom = alignBottom;
        this.el.parentElement.classList.toggle('alignBottom', alignBottom);
    }
    updateSizes = ({ label, article }) => {
        if (article)
            this.refs.sizeLabel.find(label => label.dataset.inputName === 'article').textContent = label;
        else
            this.refs.sizeLabel.find(label => label.dataset.inputName === 'article_2').textContent = label;
    };
    resize() {
        super.resize();
        this.computeAlignement();
    }
    flush() {
        if (this.resizeObserver)
            this.resizeObserver.disconnect();
        this.resizeObserver = null;
        super.flush();
    }
}
export default ProductDetails;
